export function generateToolSlug(tool: { id: string; name: string }): string {
  return tool.id || tool.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
}

export function generateCategorySlug(category: string): string {
  return category
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function getToolUrl(tool: { id: string; name: string }): string {
  return `/tools/${generateToolSlug(tool)}`;
}

export function getCategoryUrl(category: string): string {
  return `/categories/${generateCategorySlug(category)}`;
}
